<template>
  <div class="summerCamp">
    <div class="title">
      <p>浙江中医药大学夏令营报名网</p>
    </div>
    <div v-if="isTrue">
      <div class="content" v-if="status == 1">
        <div class="success" v-if="false">
          <p><i class="el-icon-circle-check"></i>你已提交成功</p>
        </div>
        <div class="box">
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="9"><span class="line">|</span> 个人信息</th>
              <tr>
                <td class="required">姓名</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.xm"
                    placeholder="请输入"
                    maxlength="50"
                  ></el-input>
                </td>
                <td class="required">性别</td>
                <td colspan="2">
                  <el-radio v-model="formData.xbm" label="男">男</el-radio>
                  <el-radio v-model="formData.xbm" label="女">女</el-radio>
                  <!-- <el-input
                    v-model="formData.xbm"
                    placeholder="请输入"
                  ></el-input> -->
                </td>
                <td class="required">民族</td>
                <td colspan="2">
                  <el-select
                    style="width: 80%"
                    v-model="formData.mzm"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in mzOptions"
                      :key="item.sqkh"
                      :label="item.tyzk"
                      :value="item.sqkh"
                    >
                    </el-option>
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="required">年龄</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.age"
                    placeholder="请输入"
                    @input="regNum(7)"
                    maxlength="3"
                  ></el-input>
                </td>
                <td class="required">身份证号码</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.zjhm"
                    placeholder="请输入"
                    maxlength="20"
                    @input="regID"
                  >
                  </el-input>
                </td>
                <td class="required">政治面貌</td>
                <td colspan="2">
                  <el-select
                    style="width: 80%"
                    v-model="formData.zzmm"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in zzmmOptions"
                      :key="item.sqkh"
                      :label="item.tyzk"
                      :value="item.sqkh"
                    >
                    </el-option>
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="required">学校名称</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.xxmc"
                    placeholder="请输入"
                    maxlength="50"
                  ></el-input>
                </td>
                <td class="required">学历</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.xlm"
                    placeholder="请输入"
                  ></el-input>
                </td>
                <td class="required">院系</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.xymc"
                    placeholder="请输入"
                    maxlength="50"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="required">专业</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.zymc"
                    placeholder="请输入"
                    maxlength="50"
                  ></el-input>
                </td>
                <td class="required">拟毕业时间</td>
                <td colspan="2">
                  <div class="block">
                    <el-date-picker
                      v-model="formData.bysj"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </div>
                </td>
                <!-- <td class="required"> 是否参评优秀营员特等奖</td>
                            <td colspan="2">
                                <el-radio v-model="formData.sfzs" label="1">是</el-radio>
                                <el-radio v-model="formData.sfzs" label="0">否</el-radio>
                            </td> -->
                <td class="required">本人银行卡号</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.yhkh"
                    placeholder="请输入(用于发放交通补贴,请准确填写)"
                    maxlength="19"
                    @input="regNum(12)"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <!-- <td class="required">是否参评优秀营员一等奖</td>
                            <td colspan="2">
                                <el-radio v-model="formData.sfpj" label="1">是</el-radio>
                                <el-radio v-model="formData.sfpj" label="0">否</el-radio>
                            </td> -->
                <td class="required">开户银行</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.khyh"
                    placeholder="请输入"
                    maxlength="30"
                  ></el-input>

                  <!-- <el-radio v-model="formData.sfpj" label="1">是</el-radio>
                                <el-radio v-model="formData.sfpj" label="0">否</el-radio> -->
                </td>
                <td class="required">邮箱</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.email"
                    placeholder="请输入"
                    maxlength="50"
                  ></el-input>
                </td>
                <td class="required">本人联系电话</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.yddh"
                    placeholder="请输入"
                    maxlength="20"
                    @input="regNum(8)"
                  >
                  </el-input>
                </td>
              </tr>
              <tr>
                <td class="required">紧急联系人电话</td>
                <td colspan="2">
                  <!-- <el-input
                    v-model="formData.lxdh"
                    placeholder="请输入"
                    maxlength="20"
                    @input="regNum(9)"
                  >
                  </el-input> -->
                  <el-input
                    v-model="formData.jjlxrdh"
                    placeholder="请输入"
                    maxlength="11"
                    @input="regNum(13)"
                  >
                  </el-input>
                </td>
                 <td class="required">家庭住址</td>
                <td colspan="4">
                  <el-input
                    v-model="formData.jtzz"
                    placeholder="请输入详细住址：包括省市区（县）街道，具体到门牌号"
                    maxlength="200"
                  
                  >
                  </el-input> 
                </td> 
                <!-- <td></td>
                <td colspan="2"></td> -->
              </tr>
              <tr>
                <td class="required">感兴趣的研究方向</td>
                <td colspan="8">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.yjfx"
                    resize="none"
                    type="textarea"
                    maxlength="300"
                    :autosize="{ minRows: 3, maxRows: 5 }"
                  >
                  </el-input>
                </td>
              </tr>
              <tr>
                <td class="required">
                  主要学习和工作经历<br />（从高中开始写起）
                </td>
                <td colspan="8">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.xxgzjl"
                    resize="none"
                    type="textarea"
                    maxlength="3000"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                  >
                  </el-input>
                </td>
              </tr>
              <tr>
                <td>科研经历</td>
                <td colspan="8">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.kyjl"
                    resize="none"
                    type="textarea"
                    maxlength="3000"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                  >
                  </el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="9"><span class="line">|</span> 成绩信息</th>
              <tr>
                <td class="required">截止目前综合成绩排名</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.rank"
                    placeholder="请输入"
                    @input="regNum(10)"
                  ></el-input>
                </td>
                <td class="required"">四级</td>
                <td colspan="2" >
                  <el-radio
                    v-model="formData.level4"
                    :label="Number(1)"
                    @change="changeL4"
                    >是</el-radio
                  >
                  <el-radio
                    v-model="formData.level4"
                    :label="Number(0)"
                    @change="changeL4"
                    >否</el-radio
                  >
                </td>
                <td :class="{required: formData.level4 == 1}">四级成绩</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.level4Grades"
                    :disabled="formData.level4 == 0"
                    placeholder="请输入"
                    @input="regNum(1)"
                    maxlength="5"
                  >
                  </el-input>
                </td>
              </tr>
              <tr>
                <td class="required">六级</td>
                <td colspan="2">
                  <el-radio
                    v-model="formData.level6"
                    :label="Number(1)"
                    @change="changeL6"
                    >是</el-radio
                  >
                  <el-radio
                    v-model="formData.level6"
                    :label="Number(0)"
                    @change="changeL6"
                    >否</el-radio
                  >
                </td>
                <td :class="{required: formData.level6 == 1}">六级成绩</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.level6Grades"
                    :disabled="formData.level6 == 0"
                    placeholder="请输入"
                    @input="regNum(2)"
                    maxlength="5"
                  >
                  </el-input>
                </td>
                <td>雅思成绩</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.ieltsScore"
                    placeholder="请输入"
                    @input="regNum(3)"
                    maxlength="5"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>托福成绩</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.toeflScores"
                    placeholder="请输入"
                    maxlength="5"
                    @input="regNum(4)"
                  >
                  </el-input>
                </td>
                <td>GRE成绩</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.greScore"
                    placeholder="请输入"
                    @input="regNum(5)"
                    maxlength="5"
                  ></el-input>
                </td>
                <td>GMAT成绩</td>
                <td colspan="2">
                  <el-input
                    v-model="formData.gmatScore"
                    placeholder="请输入"
                    maxlength="5"
                    @input="regNum(6)"
                  ></el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="9">
                <span class="line">|</span>
                <span style="color: #333">获奖</span>
              </th>
              <tr>
                <td colspan="9" style="background: #fff">
                  <el-input
                    placeholder="请输入类别、奖项名称、时间、排名等信息"
                    v-model="formData.hjxx"
                    resize="none"
                    maxlength="3000"
                    type="textarea"
                    :autosize="{ minRows: 8, maxRows: 15 }"
                  >
                  </el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="9">
                <span class="line">|</span>
                <span style="color: #333">课题</span>
              </th>
              <tr>
                <td colspan="9" style="background: #fff">
                  <el-input
                    placeholder="请输入类别、奖项名称、时间、排名等信息"
                    v-model="formData.kt"
                    resize="none"
                    maxlength="3000"
                    type="textarea"
                    :autosize="{ minRows: 8, maxRows: 15 }"
                  >
                  </el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="9">
                <span class="line">|</span>
                <span style="color: #333">学术论文</span>
              </th>
              <tr>
                <td colspan="9" style="background: #fff">
                  <el-input
                    placeholder="请输入期刊名称、论文题目、时间、排名等信息"
                    v-model="formData.xslw"
                    resize="none"
                    maxlength="3000"
                    type="textarea"
                    :autosize="{ minRows: 8, maxRows: 15 }"
                  >
                  </el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="9">
                <span class="line">|</span>
                <span style="color: #333">出版物或其他原创性成果等信息</span>
              </th>
              <tr>
                <td colspan="9" style="background: #fff">
                  <el-input
                    placeholder="请输入出版物或其他原创性成果等信息（包括时间、名称等信息）"
                    v-model="formData.yccg"
                    resize="none"
                    maxlength="3000"
                    type="textarea"
                    :autosize="{ minRows: 8, maxRows: 15 }"
                  >
                  </el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="10"><span class="line">|</span> 其他信息</th>
              <tr>
                <td colspan="1" class="required">专业人数</td>
                <td colspan="8">
                  <el-input
                    v-model="formData.zyrs"
                    placeholder="请输入"
                    @input="regNum(11)"
                    maxlength="5"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td colspan="1">其他对申请具有参考价值的<br />情况</td>
                <td colspan="8">
                  <el-input
                    placeholder="请输入获奖信息（包括获奖时间、获奖等级、获奖名称）"
                    v-model="formData.qtqk"
                    resize="none"
                    maxlength="3000"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                  >
                  </el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" cellspacing="0" cellpadding="2" class="table-one">
            <tbody>
              <th colspan="10" ><span class="line">|</span> 证明材料上传  <span class="required"></span> </th>
              <tr>
                <td colspan="10" style="background: #fff">
                  <div class="upload">
                    <p style="padding: 0 10px">
                      温馨提醒：请上传一个PDF文件，包括身份证复印件、学生证复印件，获奖证书、其他各类证书、英语水平证明、课题、学术论文、出版物或其它原创性成果等复印件（将这些文件合并为一个PDF文件。上传文件名格式：手机号码+院校+学生姓名+本科（或研究生）.pdf
                    </p>
                    <el-upload
                      class="upload-demo"
                      action="/api_camp/upload/unsafe"
                      accept=".pdf,.PDF"
                      :before-upload="handlePreview"
                      :on-remove="handleRemove"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :on-success="succFile"
                    >
                      <el-button type="primary" plain class="uploadBtn"
                        >+ 上传附件</el-button
                      >
                    </el-upload>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="sub">
          <el-button type="primary" class="subBtn" @click="submit"
            >提交</el-button
          >
        </div>
      </div>
      <div v-else-if="status == 2" class="succ">
        <img src="../../assets/none.png" alt="" />
        <p>你已成功报名中医药大学夏令营活动</p>
        <p>请等待学校确认</p>
      </div>
      <el-dialog title="提交" :visible.sync="dialogVisible" width="20%">
        <p class="subP" v-if="marked == 1">确定要提交吗？</p>
        <div v-else>
          <p class="subP">
            你已提交过报名，是否再次提交报名？<br />再提交将覆盖原来的报名数据！
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="noSub">取 消</el-button>
          <el-button type="primary" @click="sureSubmit">提 交</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="succ" v-else>
      <img src="../../assets/none.png" alt="" />
      <p>夏令营活动报名已结束！</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "summerCamp",
  data() {
    return {
      status: 1,
      formData: {
        // 姓名
        xm: "",
        // 性别
        xbm: "男",
        // 民族码
        mzm: "01",
        // 年龄
        age: "",
        // 身份证号码
        zjhm: "",
        // 政治面貌
        zzmm: "03",
        // 学校名称
        xxmc: "",
        // 学历,
        xlm: "",
        // 院系
        xymc: "",
        // 专业
        zymc: "",
        // 拟毕业时间
        bysj: "",
        // 是否参评优秀营员特等奖
        sfzs: 0,
        // 是否参评优秀营员一等奖
        sfpj: 0,
        khyh: "", // 本人银行卡号开户银行
        yhkh: "", // 本人银行卡号
        // 邮箱
        email: "",
        jtzz:'',// 家庭住址
        // 本人联系电话
        yddh: "",
        // 家长联系电话
        lxdh: "",
        jjlxrdh: "", // 紧急联系人电话
        // 感兴趣的研究方向
        yjfx: "",
        // 主要学习和工作经历
        xxgzjl: "",
        // 科研经历
        kyjl: "",
        // 成绩排名
        rank: "",
        // 四级
        level4: 1,
        // 四级成绩
        level4Grades: null,
        // 六级
        level6: 1,
        // 六级成绩
        level6Grades: null,
        // 雅思成绩
        ieltsScore: null,
        // 托福成绩
        toeflScores: null,
        // GRE成绩
        greScore: null,
        // GMAT成绩
        gmatScore: null,
        // 获奖信息
        hjxx: "",
        // 课题
        kt: "",
        // 学术论文
        xslw: "",
        // 出版物或其他原创性成果等信息
        yccg: "",
        // 专业人数
        zyrs: "",
        // 其他对申请具有参考价值的情况
        qtqk: "",
        // 附件材料名称
        fileName: "",
        // 材料地址
        url: "",
      },
      marked: 1,
      dialogVisible: false,
      isTrue: false,
      fileList: [],
      mzOptions: [],
      zzmmOptions: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    getIsTrue() {
      this.$http.get("/camp/open").then((res) => {
        const data = res.data.data;
        // console.log(data);
        this.isTrue = data;
        console.log(this.isTrue, "this.isTrue");
      });
    },
    submit() {
      if (this.formData.zjhm) {
        this.$http
          .get(`/camp/checkUser/${this.formData.zjhm}`)
          .then((res) => {
            console.log(res);
            if (res.data.data) {
              this.marked = 2;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.dialogVisible = true;
    },
    noSub() {
      this.dialogVisible = false;
    },
    sureSubmit() {
      this.dialogVisible = false;
      if (this.formData.yhkh == "") {
        this.$message({
          message: `银行卡号不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.khyh == "") {
        this.$message({
          message: `开户银行不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.jjlxrdh == "") {
        this.$message({
          message: `紧急联系人电话不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.jtzz == "") {
        this.$message({
          message: `家庭住址不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.level4 == 1 && !this.formData.level4Grades) {
        this.$message({
          message: `四级成绩不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.level6 == 1 && !this.formData.level6Grades) {
        this.$message({
          message: `六级成绩不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.zyrs == "") {
        this.$message({
          message: `专业人数不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.url == "") {
        this.$message({
          message: `证明材料不能为空`,
          type: "error",
        });
        return;
      }
      if (this.formData.level4Grades) {
        this.formData.level4Grades = Number(this.formData.level4Grades);
      }
      if (this.formData.level6Grades) {
        this.formData.level6Grades = Number(this.formData.level6Grades);
      }
      if (this.formData.ieltsScore) {
        this.formData.ieltsScore = Number(this.formData.ieltsScore);
      }
      if (this.formData.toeflScores) {
        this.formData.toeflScores = Number(this.formData.toeflScores);
      }
      if (this.formData.greScore) {
        this.formData.greScore = Number(this.formData.greScore);
      }
      if (this.formData.gmatScore) {
        this.formData.gmatScore = Number(this.formData.gmatScore);
      }
      if (this.formData.zyrs) {
        this.formData.zyrs = Number(this.formData.zyrs);
      }

      this.$http
        .post(`/camp/save`, this.formData)
        .then((res) => {
          if (res.data && res.data.code == 1000) {
            this.$message({
              message: `提交成功`,
              type: "success",
            });
            this.status = 2;
          } else {
            this.$message({
              message: `${res.data.message}`,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(7799, file);
      if (file.size > 104857600) {
        this.$message.warning(`上传文件必须在100MB以内`);
        return false;
      }
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf",'PDF'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.warning(`上传文件只能是.pdf格式`);
        return false;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // beforeRemove(file, fileList) {
    //     return this.$confirm(`确定移除 ${file.name}？`);
    // }
    regID() {
      this.formData.zjhm = this.formData.zjhm.replace(/[\W]/g, "");
    },
    regNum(i) {
      if (i == 1) {
        this.formData.level4Grades = this.formData.level4Grades.replace(
          /[^0-9.]/g,
          ""
        );
      } else if (i == 2) {
        this.formData.level6Grades = this.formData.level6Grades.replace(
          /[^0-9.]/g,
          ""
        );
      } else if (i == 3) {
        this.formData.ieltsScore = this.formData.ieltsScore.replace(
          /[^0-9.]/g,
          ""
        );
      } else if (i == 4) {
        this.formData.toeflScores = this.formData.toeflScores.replace(
          /[^0-9.]/g,
          ""
        );
      } else if (i == 5) {
        this.formData.greScore = this.formData.greScore.replace(/[^0-9.]/g, "");
      } else if (i == 6) {
        this.formData.gmatScore = this.formData.gmatScore.replace(
          /[^0-9.]/g,
          ""
        );
      } else if (i == 7) {
        this.formData.age = this.formData.age.replace(/[^0-9.]/g, "");
      } else if (i == 8) {
        this.formData.yddh = this.formData.yddh.replace(/[^0-9.]/g, "");
      } else if (i == 9) {
        this.formData.lxdh = this.formData.lxdh.replace(/[^0-9.]/g, "");
      } else if (i == 10) {
        this.formData.rank = this.formData.rank.replace(/[^0-9.]/g, "");
      } else if (i == 11) {
        this.formData.zyrs = this.formData.zyrs.replace(/[^0-9.]/g, "");
      } else if (i == 12) {
        this.formData.yhkh = this.formData.yhkh.replace(/[^0-9]/g, "");
      } else if (i == 13) {
        this.formData.jjlxrdh = this.formData.jjlxrdh.replace(/[^0-9]/g, "");
      }
    },
    loadOption() {
      this.$http
        .get(`/camp/select/mz`)
        .then((res) => {
          this.mzOptions = res.data.data;
          console.log(54, this.mzOptions);
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    loadOption1() {
      this.$http
        .get(`/camp/select/zzmm`)
        .then((res) => {
          this.zzmmOptions = res.data.data;
          console.log(5244, this.zzmmOptions);
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    succFile(file) {
      this.formData.fileName = file.data.fileName;
      this.formData.url = file.data.url;
    },
    changeL4() {
      if (this.formData.level4 == "0") {
        this.formData.level4Grades = null;
      }
    },
    changeL6() {
      if (this.formData.level6 == "0") {
        this.formData.level6Grades = null;
      }
    },
  },
  created() {
    this.getIsTrue();
    this.loadOption();
    this.loadOption1();
  },
};
</script>

<style scoped lang="scss">
.line {
  color: #333 !important;
}

.subP {
  text-align: center;
  font-size: 16px;
}

/deep/ .el-input__inner,
/deep/ .el-textarea__inner {
  border: none;
}

.summerCamp {
  width: 100%;
  height: 100vh;
  background: #f2f2f2;
  font-size: 14px;
}

.content {
  width: 1500px;
  margin: 20px auto;
  background: #fff;
  padding: 30px 20px;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 80vh;
}

.succ {
  width: 1500px;
  height: 100vh;
  background: #fff;
  text-align: center;
  margin: auto;

  img {
    width: 700px;
  }

  p {
    font-size: 30px;
  }
}

.title {
  width: 100%;
  height: 72px;
  background: linear-gradient(
    90deg,
    rgba(24, 144, 255, 1) 0%,
    rgba(24, 144, 255, 1) 0%,
    rgba(136, 199, 255, 1) 100%,
    rgba(136, 199, 255, 1) 100%
  );

  p {
    text-align: center;
    font-size: 28px;
    color: #fff;
    line-height: 72px;
    font-weight: 700;
  }
}

.success {
  width: 100%;
  text-align: center;

  p {
    font-size: 25px;
    font-weight: 600;
    color: #6ed284;
  }
}

.required:before {
  content: "*";
  color: red;
  margin-right: 5px;
}

.box {
  width: 1500px;
  margin: 30px auto;

  .table-one {
    margin-bottom: 20px;

    td {
      &:nth-child(odd) {
        background: #f2f2f2;
        padding-left: 10px;
        text-align: left;
      }

      &:nth-child(even) {
        text-align: left;
        background: #fff;
        padding-left: 10px;
      }

      .el-checkbox-group {
        padding-left: 20px;
      }
    }
  }

  table {
    width: 100%;
    border: 1px solid rgba(228, 228, 228, 1);
    border-collapse: collapse;
    color: #333;

    tbody > th {
      text-align: left;
      font-weight: 700;
      padding: 11px 2px 11px 10px;
      background: #e4e4e4;

      span {
        color: #1890ff;
      }
    }

    td {
      width: 200px;
      height: 40px;
      border: 1px solid #e5e5e5;
    }
  }
}

.upload {
  text-align: left;
  margin: 20px 0;

  p {
    font-size: 14px;
    line-height: 25px;
    color: #f64646;
  }

  .uploadBtn {
    margin: 20px 0;
  }
}

.sub {
  width: 100%;
  text-align: center;
  margin: 20px 0;
  padding-bottom: 50px;

  .subBtn {
    width: 500px;
  }
}
/deep/ .el-upload-list__item{
  width: 25%;
}
</style>
